<template>
    <div v-if="cartData && cartData.products.length" id="menu-cart" class="dropdown target">
      
      <!-- Cart Header -->
      <div class="menu-cart-head">
        <span class="fas fa-shopping-cart"></span> &nbsp;&nbsp;Your Cart
      </div>
      
    <!-- Cart Items -->
    <div id="menu-cart-items">
        <div v-for="item in cartData.products" v-bind:key="item.id" class="menu-cart-item">
            <div class="menu-cart-product-name">{{ item.quantity }}x{{ item.name }}</div>
            <span class="menu-cart-price">{{ userStore.formatPriceForUser(item.price_discount) }}</span>
            <span @click="removeItemFromCart(item.name, item.quantity)" class="cart-remove fas fa-times-circle" aria-label="Remove item from cart"></span>
        </div>
    </div>

    <div id="menu-cart-total">
        <div class="menu-cart-item">
            <div class="menu-cart-product-name"><b>Total</b></div>
            <span class="menu-cart-price">
                <s>{{ userStore.formatPriceForUser(cartData.total_regular) }}</s> &nbsp;&nbsp;
                <b class="discounted-price">{{ userStore.formatPriceForUser(cartData.total_discount) }}</b>
            </span>
        </div>
    </div>
<!--
    <div class="menu-cart-savings">
        You save: {{ userStore.formatPriceForUser(savings) }}
    </div>
-->
      <!-- Cart Actions -->
      <div id="cart-button-frame" class="center">
        <button @click.prevent="checkOut" class="fa-btn fa-btn-primary fa-btn-modal">Proceed to Checkout</button>
        <button @click="emptyCart" class="fa-btn fa-btn-secondary fa-btn-modal">Empty shopping cart</button>
      </div>
      
      <!-- Cart Notes -->
      <p class="cartnote center">
        You will be redirected to <b>MyCommerce / DigitalRiver</b> to complete your purchase.
      </p>
      <p class="cartnote center">
        <span class="fas fa-lock"></span> <i class="fa-brands fa-cc-mastercard"></i> Secure checkout
      </p>
  
    </div>
    
    <!-- Empty Cart Message -->
    <div v-else>
      Your cart is empty.
      <NuxtLink to="/shop" class="fa-btn fa-btn-primary fa-btn-modal continue-shopping">
        Continue shopping
      </NuxtLink>      
    </div>
</template>

  
<script setup>
  import { useCartStore } from '~/store/cartStore';
  import { useUserStore } from '~/store/userStore';
  import useCheckout from '~/composables/useCheckout';

  const cartStore = useCartStore();
  const userStore = useUserStore();
  const cartData = computed(() => cartStore.cartData);

  const emptyCart = () => {
    cartStore.emptyCart();
  }
  
  const { checkOut } = useCheckout();

  const removeItemFromCart = (productName, quantity) => {
    cartStore.removeFromCart(productName, quantity);
   };
</script>
  
<style lang="scss" scoped>
@import '~/assets/constants.scss';

.continue-shopping {
    margin-top: 1rem;
}

.fa-btn {
    font-size: 1rem;
}

#menu-cart-total {
    
}

.menu-cart-savings {
    color: $fa-green;  // or another positive color
    font-weight: bold;
    margin-top: 0.5rem;
}

.menu-cart-item {
    font-size: 0.75rem;
}

.menu-cart-price {
    font-size: 0.6rem;
    .discounted-price {
        color: $fa-orange;  // or another attention-grabbing color
        font-size: 1.0rem;  // slightly larger than other text
    }
}


.menu-cart-head .fa-shopping-cart,
.menu-cart-item .fa-times-circle,
#cart-button-frame {
    margin-top: 1rem;
    display: grid;
    grid-gap: 1rem;


}

.cartnote {
    font-size: 0.65rem; 
    vertical-align: middle;
}

#menu-cart-items {
    display: flex;
    flex-direction: column;
}

.menu-cart-item {
    display: grid;
    grid-template-columns: 2fr 1fr auto; 
    gap: 1rem;  
    align-items: center; 
    padding: 0.5rem 0;
}

.menu-cart-product-name {
    text-align: left;
}

.menu-cart-price {
    text-align: right;
}

.cart-remove {
    cursor: pointer;
    justify-self: center;
}

span.cart-remove.fas.fa-times-circle {
    margin: 0;
}

</style>
  